import { useSelector } from 'react-redux'

import { selectMyScopes } from 'redux/selectors/MyScopes'

export const useMyScopes = () => {
  return useSelector(selectMyScopes)
}
